import { render } from "./ArchivedTasks.vue?vue&type=template&id=ea339654&scoped=true"
import script from "./ArchivedTasks.vue?vue&type=script&lang=js"
export * from "./ArchivedTasks.vue?vue&type=script&lang=js"

import "./ArchivedTasks.vue?vue&type=style&index=0&id=ea339654&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea339654"]])

export default __exports__